module.exports = __webpack_public_path__ + "img/wayAdd@2x.2987f029.png";